// Literally maps to the type used by the action for navigation.
export const getLocation = state => state.location
export const getRouteType = state => state.location.type
export const getRoutesMap = state => state.location.routesMap
export const getCurrentRecordId = state => state.location.payload.id

// Session related selector map
// export const getUsers = state => state.users
// export const getLoggedUserId = state => state.auth
// export const getLoggedUser = state => getUsers(state)[getLoggedUserId(state)]
export const getLoggedUser = state => state.auth

export const getCurrentRoute = state => state.location.routesMap[state.location.type]

// Rest api parameters selector generator
export const checkListParams = resource => state =>
  !!Object.keys(state.rest[resource].list.params).length

// export const getListParams = resource => state => {
//   const def = state.location.routesMap[state.location.type].defaultParams
//   const curr = state.rest[resource].list.params

//   const out = [
//     resource,
//     {
//       perPage: curr.perPage || def.perPage,
//       page: curr.page || def.page
//     },
//     {
//       field: curr.sort || def.sort,
//       order: curr.order || def.order
//     },
//     { ...def.filter, ...curr.filter }
//   ]
//   return out
// }

export const getListParams = resource => state => {
  const curr = state.rest[resource].list.params

  const out = [
    resource,
    {
      perPage: curr.perPage,
      page: curr.page,
    },
    {
      field: curr.sort,
      order: curr.order,
    },
    curr.filter,
  ]
  return out
}



// WEBPACK FOOTER //
// ./state/selectors.js